import css from "../styles/Footer.module.css";
import { ASSETS_BASE_URL, RETURN_POLICY } from "../constants";

// MUI
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import GlyMedLogo from "./icons/GlymedLogo";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import SocialMedia from "./SocialMedia";
import { useLocation } from "react-router-dom";
import useProductResources from "../hooks/useProductResources";

export const Footer = () => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));
  const location = useLocation();
  const { productRubricPdf } = useProductResources();

  return (
    <footer id="glymed-footer" className={css["gy-footer"]}>
      <div className={css["gy-footer-wrapper"]}>
        <Container fixed maxWidth={"xl"}>
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <GlyMedLogo
                  color="white"
                  styles={
                    matches
                      ? { display: "block", margin: "0 auto 10px" }
                      : { marginBottom: "10px" }
                  }
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <div className={css["gy-footer-address"]}>
                  <div>
                    <a className={css.linkTag} href={"tel:800.676.9667"}>
                      800-676-9667
                    </a>
                  </div>
                  <div>
                    <a
                      className={css.linkTag}
                      href={"mailto:info@glymedplus.com"}
                    >
                      info@glymedplus.com
                    </a>
                  </div>

                  <p>867 East 2260 South Provo, UT 84606</p>
                  <SocialMedia
                    color={"#fff"}
                    className={css["gy-social-media"]}
                  />
                </div>
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <div className={css["gy-footer-right"]}>
                  {location?.pathname === "/products" && <div>
                    <a
                      className={css.linkTag}
                      target="_blank"
                      rel="noopener noreferrer"
                      href={productRubricPdf}
                    >
                      Product Reference Guide
                    </a>
                  </div>}

                  <div>
                    <a
                      className={css.linkTag}
                      target="_blank"
                      rel="noopener noreferrer"
                      href={`${ASSETS_BASE_URL}/static/privacy.html`}
                    >
                      Privacy Policy
                    </a>
                  </div>

                  <div>
                    <a
                      className={css.linkTag}
                      target="_blank"
                      rel="noopener noreferrer"
                      href={`${ASSETS_BASE_URL}/static/termsofservicepro.html`}
                    >
                      Terms of Service
                    </a>
                  </div>

                  <div>
                    <a
                      className={css.linkTag}
                      target="_blank"
                      rel="noopener noreferrer"
                      href={`${ASSETS_BASE_URL}/static/${RETURN_POLICY}`}
                    >
                      Return Policy
                    </a>
                  </div>

                  <p className={css["gy-footer-final"]}>
                    Copyright ©{new Date().getFullYear()} GlyMed Plus. All
                    rights reserved.
                  </p>
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;
